export default __webpack_public_path__ + "static/media/bg2.7afe46cc.png";